import {
    AccountManagerIcon,
    BatteryIcon,
    BookletIcon,
    CarCheckIcon,
    CarIcon,
    GuidesIcon,
    MenuBookCorrectionIcon,
    MenuBookIcon,
    OilCanIcon,
    PhoneIcon,
    PushPinIcon,
    SpeedVelocimeterIcon,
    TechTipsIcon,
    TreeTroubleshootingIcon,
    VideoIcon,
} from '@web/vin-sessions/assets/Icons';
import { publicationTypes } from '@web/vin-sessions/utils/vinSessionUtils';
import React, { FC } from 'react';

export type PublicationTypeName =
    | string
    | 'QMR Reports'
    | 'Techline Cases'
    | 'BMIS Test'
    | 'Troubleshooting Guide'
    | 'TechTIPS NewsLetter'
    | 'Service Manual'
    | 'Accessory Installation Guide'
    | 'Owner Manual'
    | 'Service Manual Correction'
    | 'Service Diagnostics'
    | 'Maintenance Advisory Bulletin'
    | 'Product/Campaign Bulletin'
    | 'Technical Reference Booklet'
    | 'Video'
    | 'Warranty Booklet'
    | 'Warranty Bulletin'
    | 'On-Board Diag II Information'
    | 'Technical Service Bulletin';

interface PublicationTypeProps {
    publicationType: PublicationTypeName;
    size: number;
}

const iconMapping: Record<PublicationTypeName, (props: { size: number }) => JSX.Element> = {
    treeTroubleshooting: TreeTroubleshootingIcon,
    techTips: TechTipsIcon,
    menuBook: MenuBookIcon,
    guides: GuidesIcon,
    accountManager: SpeedVelocimeterIcon,
    speedVelocimeter: AccountManagerIcon,
    menuBookCorrection: MenuBookCorrectionIcon,
    oilCan: OilCanIcon,
    pushPin: PushPinIcon,
    booklet: BookletIcon,
    carCheck: CarCheckIcon,
    video: VideoIcon,
};

export const PublicationType: FC<PublicationTypeProps> = ({ publicationType, size }) => {
    let icon;
    icon = publicationTypes.find((publication) => publication.icon == publicationType) || {
        icon: 'carCheck',
    };
    if (icon.icon === 'carCheck') {
        icon = publicationTypes.find((publication) => publication.publicationType == publicationType) || {
            icon: 'carCheck',
        };
    }
    let IconComponent = iconMapping[icon?.icon];

    return <IconComponent size={size} />;
};
